import { api } from "@services/api"
import {
  //   addToCartService,
  getOrderService,
  getOrdersService,
  getAllOrdersService,
  getOrdersProcessingService,
  updateOrderService,
  archiveOrderService,
  getArchivedOrdersService,
} from "./orders-service"

export const ordersApi = api.injectEndpoints({
  endpoints: (build) => ({
    //get a single order
    getOrder: build.query({
      queryFn: async (props) => {
        const result: any = await new Promise((resolve) =>
          getOrderService(props)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Orders"],
    }),

    //get orders
    getOrders: build.query({
      queryFn: async (props) => {
        const result: any = await new Promise((resolve) =>
          getOrdersService(props)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Orders"],
    }),

    //get all orders
    getAllOrders: build.query({
      // add another security layer to pull the role of the user requesting and disallow if not admin or processor
      queryFn: async (prop) => {
        const result: any = await new Promise((resolve) =>
          getAllOrdersService(prop)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Orders"],
    }),

    //get order being processed
    getOrdersProcessing: build.query({
      queryFn: async ({ uid }) => {
        const result: any = await new Promise((resolve) =>
          getOrdersProcessingService(uid)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },
      providesTags: ["Orders"],
    }),

    //get order being processed
    updateOrder: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          updateOrderService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },
      invalidatesTags: ["Orders"],
    }),

    //archive order
    archiveOrder: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          archiveOrderService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },
      invalidatesTags: ["Orders"],
    }),

    //get archived orders by uid
    getArchivedOrders: build.mutation({
      queryFn: async ({ uid }: { uid: string }) => {
        const result: any = await new Promise((resolve) =>
          getArchivedOrdersService(uid)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },
    }),
  }),
})

export const {
  useGetOrderQuery,
  useGetOrdersQuery,
  useGetAllOrdersQuery,
  useGetOrdersProcessingQuery,
  useUpdateOrderMutation,
  useArchiveOrderMutation,
  useGetArchivedOrdersMutation,
} = ordersApi
